module.exports = [
  {
    path: '/',
    pattern: /^(?:\/(?=$))?$/i,
    keys: [],
    component: './routes/Home',
    data: {"articles":"GET https://gist.githubusercontent.com/koistya/a32919e847531320675764e7308b796a/raw/articles.json"},
    load() {
      return Promise.resolve(require('./routes/Home').default);
    },
  },
  {
    path: '/error',
    pattern: /^\/error(?:\/(?=$))?$/i,
    keys: [],
    component: './routes/Error',
    load() {
      return Promise.resolve(require('./routes/Error').default);
    },
  },
  {
    path: '/tasks/:status(pending|completed)?',
    pattern: /^\/tasks(?:\/((?:pending|completed)))?(?:\/(?=$))?$/i,
    keys: [{"name":"status","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"pending|completed"}],
    component: './routes/Home',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./routes/Home'], function (require) {
            resolve(require('./routes/Home').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
];


// WEBPACK FOOTER //
// ./routes.json